import '@angular/common/locales/global/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { installMonacoWorkers } from './monaco-workers';

if (typeof window !== 'undefined') {
  installMonacoWorkers();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));